module.exports = __webpack_public_path__ + "img/rewind.3781baac.svg";